"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformEditorDataToCSVText = exports.transformEditorDataToText = exports.transformBlockToPlainText = exports.transformBlockToText = exports.createEditorParagraph = exports.transformEditorDataToHTML = exports.transformHtmlToEditorFormat = void 0;
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const editorjs_html_1 = __importDefault(require("editorjs-html"));
const string_util_1 = require("./string.util");
const htmlTagRegexp = /(<([^>]+)>)/ig;
const multiSpaceRegexp = / {2,}/g;
const multiLineRegexp = /\n{2,}/g;
var BlockTypes;
(function (BlockTypes) {
    BlockTypes["paragraph"] = "paragraph";
    BlockTypes["header"] = "header";
    BlockTypes["list"] = "header";
    BlockTypes["checklist"] = "checklist";
    BlockTypes["delimiter"] = "delimiter";
    BlockTypes["image"] = "image";
    // more to come later
})(BlockTypes || (BlockTypes = {}));
const getEditorBlock = (type, data) => ({
    type,
    data,
});
const getEditorObject = (blocks) => ({
    blocks,
});
const transformHtmlToEditorFormat = (content) => {
    try {
        const result = content
            .replace(/\sstyle=".*?"/gi, "")
            .replace(/<\/p>/g, "")
            .replace(/<\/ul>/gi, "")
            .replace(/<\/?br>/gi, "")
            .split(/<p>|<ul>/gi)
            // this is for cases when <h1|h2...> are not wrapped with <p> tag
            .map((content) => {
            let start = 0;
            let end = 0;
            const arr = [];
            while (content.trim() !== "") {
                content = content.substring(end, content.length);
                start = content.search(/<h\d>/);
                end = content.search(/\/h\d>/) + 4;
                if (start < 0 || end < 0) {
                    arr.push(content);
                    break;
                }
                arr.push(content.substring(0, start));
                arr.push(content.substring(start, end));
            }
            return arr.filter(_ => _);
        })
            .flat()
            .map((e) => {
            const headerRegexp = /<h(\d)>(.*)<\/h\d>/g;
            const header = headerRegexp.exec(e);
            if (header) {
                const [, level, text] = header;
                const data = {
                    text,
                    level: +level,
                };
                return getEditorBlock("header", data);
            }
            const unorderedListRegexp = /<li>(.*?)<\/li>/g;
            const list = unorderedListRegexp.exec(e);
            if (list) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                const unorderedListContent = e.match(unorderedListRegexp).map((t) => t.replace(/<\/?li>/g, ""));
                const data = {
                    style: "unordered",
                    items: unorderedListContent,
                };
                return getEditorBlock("list", data);
            }
            const data = { text: e };
            return getEditorBlock("paragraph", data);
        });
        return getEditorObject(result);
    }
    catch (e) {
        const data = { text: content };
        const defaultBlock = getEditorBlock("paragraph", data);
        return getEditorObject([defaultBlock]);
    }
};
exports.transformHtmlToEditorFormat = transformHtmlToEditorFormat;
const transformEditorDataToHTML = (data) => {
    const checklistParser = (block) => {
        const content = block.data.items.reduce((r, item) => `${r}${item.checked ? "[*]" : "[ ]"} ${item.text}<br>`, "");
        return `<p>${content}</p>`;
    };
    const paragraphParser = (block) => {
        const content = block.data.text
            .replace(multiLineRegexp, "\n");
        return `<p>${content}</p>`;
    };
    const edjsParser = (0, editorjs_html_1.default)({
        checklist: checklistParser,
        paragraph: paragraphParser,
    });
    const html = edjsParser.parse(data);
    return (0, string_util_1.replaceHtmlSpecialCharacters)(html.join(""))
        .replace(multiSpaceRegexp, " ")
        .replace(multiLineRegexp, "\n\n")
        .replace(/\n/g, "<br>");
};
exports.transformEditorDataToHTML = transformEditorDataToHTML;
const createEditorParagraph = (text) => ({
    type: BlockTypes.paragraph,
    data: { text },
});
exports.createEditorParagraph = createEditorParagraph;
const transformBlockToText = (block) => {
    if (!block.type) {
        return "";
    }
    let text;
    switch (block.type) {
        case "list":
            if (block.data.style === "ordered") {
                text = block.data.items.reduce((r, item, i) => `${r}${i + 1}. ${item}\n`, "");
            }
            else {
                text = block.data.items.reduce((r, item) => `${r}— ${item}\n`, "");
            }
            break;
        case "checklist":
            text = block.data.items.reduce((r, item) => `${r}${item.checked ? "[*]" : "[ ]"} ${item.text}\n`, "");
            break;
        default:
            text = block.data.text || "";
            break;
    }
    return (0, string_util_1.replaceHtmlSpecialCharacters)(text)
        .replace(multiLineRegexp, "\n")
        .replace(/<br>/g, "\n");
};
exports.transformBlockToText = transformBlockToText;
const transformBlockToPlainText = (block) => {
    const htmlText = (0, exports.transformBlockToText)(block);
    return htmlText
        .replace(htmlTagRegexp, "")
        .replace(multiSpaceRegexp, " ")
        .replace(multiLineRegexp, "\n\n");
};
exports.transformBlockToPlainText = transformBlockToPlainText;
const transformEditorDataToText = (editorData) => {
    if (!editorData)
        return "";
    const plainText = (editorData === null || editorData === void 0 ? void 0 : editorData.blocks) && editorData.blocks.reduce((result, block) => {
        const blockText = (0, exports.transformBlockToText)(block);
        return `${result + blockText}\n\n`;
    }, "");
    return plainText
        .replace(htmlTagRegexp, "")
        .replace(multiSpaceRegexp, " ")
        .replace(multiLineRegexp, "\n\n");
};
exports.transformEditorDataToText = transformEditorDataToText;
const transformEditorDataToCSVText = (editorData) => {
    if (!editorData)
        return "";
    const csvText = (editorData === null || editorData === void 0 ? void 0 : editorData.blocks) && editorData.blocks.reduce((result, block) => {
        const blockText = (0, exports.transformBlockToText)(block);
        return `${`${result}"${blockText}"`}\n`;
    }, "");
    return csvText;
};
exports.transformEditorDataToCSVText = transformEditorDataToCSVText;
